(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4128,2636,5918,5190],{

/***/ 84441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(2888);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.js
var use_unmount_effect = __webpack_require__(6717);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-force-update.js




function useForceUpdate() {
    var unloadingRef = (0,react.useRef)(false);
    var _a = (0,tslib_es6/* __read */.CR)((0,react.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () { return (unloadingRef.current = true); });
    return (0,react.useCallback)(function () {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.js
var PresenceContext = __webpack_require__(8626);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.js
var use_constant = __webpack_require__(45930);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.js





var presenceId = 0;
function getPresenceId() {
    var id = presenceId;
    presenceId++;
    return id;
}
var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    var id = (0,use_constant/* useConstant */.h)(getPresenceId);
    var context = (0,react.useMemo)(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            presenceChildren.set(childId, true);
            var allComplete = true;
            presenceChildren.forEach(function (isComplete) {
                if (!isComplete)
                    allComplete = false;
            });
            allComplete && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); }, 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    (0,react.useMemo)(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (react.createElement(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js + 1 modules
var SharedLayoutContext = __webpack_require__(62134);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js







function getChildKey(child) {
    return child.key || "";
}
function updateChildLookup(children, allChildren) {
    var seenChildren =  false ? 0 : null;
    children.forEach(function (child) {
        var key = getChildKey(child);
        if (false) {}
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, function (child) {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = useForceUpdate();
    var layoutContext = (0,react.useContext)(SharedLayoutContext/* SharedLayoutContext */.WH);
    if ((0,SharedLayoutContext/* isSharedLayout */.Md)(layoutContext)) {
        forceRender = layoutContext.forceUpdate;
    }
    var isInitialRender = (0,react.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0,react.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0,react.useRef)(new Map())
        .current;
    // A living record of all currently exiting components.
    var exiting = (0,react.useRef)(new Set()).current;
    updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return (react.createElement(react.Fragment, null, filteredChildren.map(function (child) { return (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
        else {
            // In case this key has re-entered, remove from the exiting list
            exiting.delete(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function (key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    presentChildren.current = childrenToRender;
    if (false) {}
    return (react.createElement(react.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return (0,react.cloneElement)(child); })));
};




/***/ }),

/***/ 64777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ useCycle; }
});

// EXTERNAL MODULE: ./node_modules/framer-motion/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(2888);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/popmotion/dist/es/utils/wrap.js
var wrap = function (min, max, v) {
    var rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-cycle.js




/**
 * Cycles through a series of visual properties. Can be used to toggle between or cycle through animations. It works similar to `useState` in React. It is provided an initial array of possible states, and returns an array of two arguments.
 *
 * @library
 *
 * ```jsx
 * import * as React from "react"
 * import { Frame, useCycle } from "framer"
 *
 * export function MyComponent() {
 *   const [x, cycleX] = useCycle(0, 50, 100)
 *
 *   return (
 *     <Frame
 *       animate={{ x: x }}
 *       onTap={() => cycleX()}
 *      />
 *    )
 * }
 * ```
 *
 * @motion
 *
 * An index value can be passed to the returned `cycle` function to cycle to a specific index.
 *
 * ```jsx
 * import * as React from "react"
 * import { motion, useCycle } from "framer-motion"
 *
 * export const MyComponent = () => {
 *   const [x, cycleX] = useCycle(0, 50, 100)
 *
 *   return (
 *     <motion.div
 *       animate={{ x: x }}
 *       onTap={() => cycleX()}
 *      />
 *    )
 * }
 * ```
 *
 * @param items - items to cycle through
 * @returns [currentState, cycleState]
 *
 * @public
 */
function useCycle() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    var index = (0,react.useRef)(0);
    var _a = (0,tslib_es6/* __read */.CR)((0,react.useState)(items[index.current]), 2), item = _a[0], setItem = _a[1];
    return [
        item,
        function (next) {
            index.current =
                typeof next !== "number"
                    ? wrap(0, items.length, index.current + 1)
                    : next;
            setItem(items[index.current]);
        },
    ];
}




/***/ }),

/***/ 32476:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/usecases",
      function () {
        return __webpack_require__(49126);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_usecases; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./public/img/useCases/TrainingAndHackathons.png
var TrainingAndHackathons = __webpack_require__(5605);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(5950);
// EXTERNAL MODULE: ./node_modules/react-elastic-carousel/dist/index.es.js + 7 modules
var index_es = __webpack_require__(27082);
;// CONCATENATED MODULE: ./src/pages/UseCases/UseCasesCarosel.js










var UseCasesCarousel = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(UseCasesCarousel, PureComponent);
    var _super = (0,_create_super/* default */.Z)(UseCasesCarousel);
    function UseCasesCarousel(props) {
        (0,_class_call_check/* default */.Z)(this, UseCasesCarousel);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "eventCard", function(event, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "usecases-card d-flex mr-3 flex-column align-items-center justify-content-center",
                title: event.name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-flex flex-column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: event.image,
                        className: "w-100 h-100",
                        alt: event.name,
                        loading: "lazy"
                    })
                })
            }, index);
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onNextStart", function(currentItem, nextItem, element) {
            if (currentItem.index === nextItem.index) {
                element.current.goTo(0);
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onPrevStart", function(currentItem, nextItem, element) {
            if (currentItem.index === nextItem.index) {
                element.current.goTo(_this.props.data.length);
            }
        });
        _this.resetTimeout = null;
        _this.catouselRefMD = /*#__PURE__*/ (0,react.createRef)();
        _this.catouselRefLG = /*#__PURE__*/ (0,react.createRef)();
        _this.catouselRefXL = /*#__PURE__*/ (0,react.createRef)();
        _this.catouselRefSM = /*#__PURE__*/ (0,react.createRef)();
        return _this;
    }
    (0,_create_class/* default */.Z)(UseCasesCarousel, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var showDots = this.props.data.length <= 6;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-b34ba6c4acbc7497" + " " + "row g-0 py-3 py-md-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-b34ba6c4acbc7497" + " " + "col d-none d-md-block d-lg-none d-xl-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                        ref: this.catouselRefMD,
                                        itemsToShow: 3,
                                        infinite: true,
                                        enableAutoPlay: true,
                                        autoPlaySpeed: 2000,
                                        onNextStart: function(currentItem, nextItem) {
                                            return _this.onNextStart(currentItem, nextItem, _this.catouselRefMD);
                                        },
                                        onPrevStart: function(currentItem, nextItem) {
                                            return _this.onPrevStart(currentItem, nextItem, _this.catouselRefMD);
                                        },
                                        onNextEnd: function() {
                                            clearTimeout(_this.resetTimeout);
                                            _this.resetTimeout = setTimeout(function() {
                                                var ref, ref1;
                                                (ref = _this.catouselRefXL) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.goTo(0);
                                            }, 2000);
                                        },
                                        disableArrowsOnEnd: false,
                                        disableArrowsOnStart: false,
                                        showArrows: false,
                                        children: this.props.data.map(this.eventCard)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-b34ba6c4acbc7497" + " " + "col d-none d-md-none d-lg-block d-xl-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                        ref: this.catouselRefLG,
                                        infinite: true,
                                        enableAutoPlay: true,
                                        itemsToShow: 4,
                                        autoPlaySpeed: 2000,
                                        onNextStart: function(currentItem, nextItem) {
                                            return _this.onNextStart(currentItem, nextItem, _this.catouselRefLG);
                                        },
                                        onPrevStart: function(currentItem, nextItem) {
                                            return _this.onPrevStart(currentItem, nextItem, _this.catouselRefLG);
                                        },
                                        onNextEnd: function() {
                                            clearTimeout(_this.resetTimeout);
                                            _this.resetTimeout = setTimeout(function() {
                                                var ref, ref1;
                                                (ref = _this.catouselRefXL) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.goTo(0);
                                            }, 2000);
                                        },
                                        disableArrowsOnEnd: false,
                                        disableArrowsOnStart: false,
                                        showArrows: false,
                                        children: this.props.data.map(this.eventCard)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-b34ba6c4acbc7497" + " " + "col d-none d-md-none d-lg-none d-xl-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                        ref: this.catouselRefXL,
                                        itemsToShow: 6,
                                        infinite: true,
                                        pagination: !showDots,
                                        autoPlaySpeed: 2000,
                                        enableAutoPlay: true,
                                        onNextStart: function(currentItem, nextItem) {
                                            return _this.onNextStart(currentItem, nextItem, _this.catouselRefXL);
                                        },
                                        onPrevStart: function(currentItem, nextItem) {
                                            return _this.onPrevStart(currentItem, nextItem, _this.catouselRefXL);
                                        },
                                        onNextEnd: function() {
                                            clearTimeout(_this.resetTimeout);
                                            _this.resetTimeout = setTimeout(function() {
                                                var ref, ref1;
                                                (ref = _this.catouselRefXL) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.goTo(0);
                                            }, 2000);
                                        },
                                        disableArrowsOnEnd: false,
                                        disableArrowsOnStart: false,
                                        showArrows: false,
                                        children: this.props.data.map(this.eventCard)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-b34ba6c4acbc7497" + " " + "col d-block d-md-none d-lg-none d-xl-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                        ref: this.catouselRefSM,
                                        itemsToShow: 1,
                                        infinite: true,
                                        autoPlaySpeed: 2000,
                                        enableAutoPlay: true,
                                        onNextStart: function(currentItem, nextItem) {
                                            return _this.onNextStart(currentItem, nextItem, _this.catouselRefSM);
                                        },
                                        onPrevStart: function(currentItem, nextItem) {
                                            return _this.onPrevStart(currentItem, nextItem, _this.catouselRefSM);
                                        },
                                        onNextEnd: function() {
                                            clearTimeout(_this.resetTimeout);
                                            _this.resetTimeout = setTimeout(function() {
                                                var ref, ref1;
                                                (ref = _this.catouselRefXL) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.goTo(0);
                                            }, 2000);
                                        },
                                        disableArrowsOnEnd: false,
                                        disableArrowsOnStart: false,
                                        showArrows: false,
                                        children: this.props.data.map(this.eventCard)
                                    })
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)((style_default()), {
                            id: "b34ba6c4acbc7497",
                            children: ".usecases-card.jsx-b34ba6c4acbc7497{background:#23313e;-webkit-box-shadow:3px 3px 20px rgba(0,0,0,.25);-moz-box-shadow:3px 3px 20px rgba(0,0,0,.25);box-shadow:3px 3px 20px rgba(0,0,0,.25);border:4px solid#fff;-webkit-border-radius:.5px;-moz-border-radius:.5px;border-radius:.5px;margin:20px}@media screen and (max-width:480px){.usecases-card.jsx-b34ba6c4acbc7497{margin:0px}}"
                        })
                    ]
                });
            }
        }
    ]);
    return UseCasesCarousel;
}(react.PureComponent);
/* harmony default export */ var UseCasesCarosel = (UseCasesCarousel);

// EXTERNAL MODULE: ./public/img/useCases/Conference/AWSCDSingapore2.jpg
var AWSCDSingapore2 = __webpack_require__(81084);
var AWSCDSingapore2_default = /*#__PURE__*/__webpack_require__.n(AWSCDSingapore2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/AWSCDSriLanka2.jpg
var AWSCDSriLanka2 = __webpack_require__(55124);
var AWSCDSriLanka2_default = /*#__PURE__*/__webpack_require__.n(AWSCDSriLanka2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/AWSCDVirtualEdition2.jpg
var AWSCDVirtualEdition2 = __webpack_require__(16043);
var AWSCDVirtualEdition2_default = /*#__PURE__*/__webpack_require__.n(AWSCDVirtualEdition2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/AWSPune.jpg
var AWSPune = __webpack_require__(87382);
var AWSPune_default = /*#__PURE__*/__webpack_require__.n(AWSPune);
// EXTERNAL MODULE: ./public/img/useCases/Conference/DataOpsObservabilityConf2.jpg
var DataOpsObservabilityConf2 = __webpack_require__(4525);
var DataOpsObservabilityConf2_default = /*#__PURE__*/__webpack_require__.n(DataOpsObservabilityConf2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/DevfestAurangabad2.jpg
var DevfestAurangabad2 = __webpack_require__(63013);
var DevfestAurangabad2_default = /*#__PURE__*/__webpack_require__.n(DevfestAurangabad2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/DevNation2.jpg
var DevNation2 = __webpack_require__(27428);
var DevNation2_default = /*#__PURE__*/__webpack_require__.n(DevNation2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/DevOpsDaysIndia2.jpg
var DevOpsDaysIndia2 = __webpack_require__(41393);
var DevOpsDaysIndia2_default = /*#__PURE__*/__webpack_require__.n(DevOpsDaysIndia2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/ExpertsLive2.jpg
var ExpertsLive2 = __webpack_require__(86502);
var ExpertsLive2_default = /*#__PURE__*/__webpack_require__.n(ExpertsLive2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/GDGPune2023.jpg
var GDGPune2023 = __webpack_require__(15324);
var GDGPune2023_default = /*#__PURE__*/__webpack_require__.n(GDGPune2023);
// EXTERNAL MODULE: ./public/img/useCases/Conference/JECRCCLOUDSUMMIT2.jpg
var JECRCCLOUDSUMMIT2 = __webpack_require__(51538);
var JECRCCLOUDSUMMIT2_default = /*#__PURE__*/__webpack_require__.n(JECRCCLOUDSUMMIT2);
// EXTERNAL MODULE: ./public/img/useCases/Conference/KCDMumbai.jpg
var KCDMumbai = __webpack_require__(12640);
var KCDMumbai_default = /*#__PURE__*/__webpack_require__.n(KCDMumbai);
// EXTERNAL MODULE: ./public/img/useCases/Conference/PyConfHyderabad2.jpg
var PyConfHyderabad2 = __webpack_require__(75487);
var PyConfHyderabad2_default = /*#__PURE__*/__webpack_require__.n(PyConfHyderabad2);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/AzugaLogo2.jpg
var AzugaLogo2 = __webpack_require__(94473);
var AzugaLogo2_default = /*#__PURE__*/__webpack_require__.n(AzugaLogo2);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/DM2.jpg
var DM2 = __webpack_require__(6263);
var DM2_default = /*#__PURE__*/__webpack_require__.n(DM2);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/EduHub.jpg
var EduHub = __webpack_require__(28099);
var EduHub_default = /*#__PURE__*/__webpack_require__.n(EduHub);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/Flutternashik.jpg
var Flutternashik = __webpack_require__(56757);
var Flutternashik_default = /*#__PURE__*/__webpack_require__.n(Flutternashik);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/GDGTrichy.jpg
var GDGTrichy = __webpack_require__(2687);
var GDGTrichy_default = /*#__PURE__*/__webpack_require__.n(GDGTrichy);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/ReCap.jpg
var ReCap = __webpack_require__(31537);
var ReCap_default = /*#__PURE__*/__webpack_require__.n(ReCap);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/SodaFoundation.jpg
var SodaFoundation = __webpack_require__(48719);
var SodaFoundation_default = /*#__PURE__*/__webpack_require__.n(SodaFoundation);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/StudyJam.jpg
var StudyJam = __webpack_require__(61418);
var StudyJam_default = /*#__PURE__*/__webpack_require__.n(StudyJam);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/WomenInData.jpg
var WomenInData = __webpack_require__(48722);
var WomenInData_default = /*#__PURE__*/__webpack_require__.n(WomenInData);
// EXTERNAL MODULE: ./public/img/useCases/MeetupsAndWebinars/WOW.jpg
var WOW = __webpack_require__(66872);
var WOW_default = /*#__PURE__*/__webpack_require__.n(WOW);
// EXTERNAL MODULE: ./public/img/useCases/TechFestsHackathons/GDSCWOWPUNE.jpg
var GDSCWOWPUNE = __webpack_require__(46551);
var GDSCWOWPUNE_default = /*#__PURE__*/__webpack_require__.n(GDSCWOWPUNE);
// EXTERNAL MODULE: ./public/img/useCases/TechFestsHackathons/Prakarsh2.jpg
var Prakarsh2 = __webpack_require__(39654);
var Prakarsh2_default = /*#__PURE__*/__webpack_require__.n(Prakarsh2);
// EXTERNAL MODULE: ./public/img/useCases/TechFestsHackathons/Samhita.jpg
var Samhita = __webpack_require__(90598);
var Samhita_default = /*#__PURE__*/__webpack_require__.n(Samhita);
// EXTERNAL MODULE: ./public/img/useCases/TechFestsHackathons/Tharang2.jpg
var Tharang2 = __webpack_require__(43182);
var Tharang2_default = /*#__PURE__*/__webpack_require__.n(Tharang2);
// EXTERNAL MODULE: ./public/img/useCases/WorkshopsTrainings/AWS.jpg
var AWS = __webpack_require__(17064);
var AWS_default = /*#__PURE__*/__webpack_require__.n(AWS);
// EXTERNAL MODULE: ./public/img/useCases/WorkshopsTrainings/EthnusTech.jpg
var EthnusTech = __webpack_require__(82759);
var EthnusTech_default = /*#__PURE__*/__webpack_require__.n(EthnusTech);
// EXTERNAL MODULE: ./public/img/useCases/WorkshopsTrainings/IWD2023.jpg
var IWD2023 = __webpack_require__(55157);
var IWD2023_default = /*#__PURE__*/__webpack_require__.n(IWD2023);
// EXTERNAL MODULE: ./public/img/useCases/WorkshopsTrainings/JavaScriptMeetup.jpg
var JavaScriptMeetup = __webpack_require__(5748);
var JavaScriptMeetup_default = /*#__PURE__*/__webpack_require__.n(JavaScriptMeetup);
// EXTERNAL MODULE: ./public/img/useCases/WorkshopsTrainings/KotlinConfKUGKolkata1.jpg
var KotlinConfKUGKolkata1 = __webpack_require__(4715);
var KotlinConfKUGKolkata1_default = /*#__PURE__*/__webpack_require__.n(KotlinConfKUGKolkata1);
// EXTERNAL MODULE: ./public/img/useCases/WorkshopsTrainings/UpesacmTech.jpg
var UpesacmTech = __webpack_require__(46798);
var UpesacmTech_default = /*#__PURE__*/__webpack_require__.n(UpesacmTech);
;// CONCATENATED MODULE: ./src/pages/UseCases/Constants.js

































// Images based on sections available on the use cases page
var Section1 = [
    {
        name: "AWS CD Singapore",
        image: (AWSCDSingapore2_default())
    },
    {
        name: "AWS CD SriLanka",
        image: (AWSCDSriLanka2_default())
    },
    {
        name: "AWS CD Virtual Edition",
        image: (AWSCDVirtualEdition2_default())
    },
    {
        name: "AWS Pune",
        image: (AWSPune_default())
    },
    {
        name: "DataOps Observability Conf2",
        image: (DataOpsObservabilityConf2_default())
    },
    {
        name: "Devfest Aurangabad",
        image: (DevfestAurangabad2_default())
    },
    {
        name: "Dev Nation",
        image: (DevNation2_default())
    },
    {
        name: "Dev Ops DaysIndia",
        image: (DevOpsDaysIndia2_default())
    },
    {
        name: "Experts Live",
        image: (ExpertsLive2_default())
    },
    {
        name: "GDG Pune 2023",
        image: (GDGPune2023_default())
    },
    {
        name: "JECRC CLOUD SUMMIT 2",
        image: (JECRCCLOUDSUMMIT2_default())
    },
    {
        name: "KCD Mumbai",
        image: (KCDMumbai_default())
    },
    {
        name: "PyConf Hyderabad",
        image: (PyConfHyderabad2_default())
    }, 
];
var Section2 = [
    {
        name: "GDSC WOW PUNE",
        image: (GDSCWOWPUNE_default())
    },
    {
        name: "Prakarsh 2",
        image: (Prakarsh2_default())
    },
    {
        name: "Samhita",
        image: (Samhita_default())
    },
    {
        name: "Tharang",
        image: (Tharang2_default())
    },
    {
        name: "Flutter Nashik",
        image: (AzugaLogo2_default())
    },
    {
        name: "DM",
        image: (DM2_default())
    },
    {
        name: "Kotlin Kolkata 2k23",
        image: (DevOpsDaysIndia2_default())
    }, 
];
var Section3 = [
    {
        name: "AWS",
        image: (AWS_default())
    },
    {
        name: "Ethnus Tech",
        image: (EthnusTech_default())
    },
    {
        name: "IWD 2023",
        image: (IWD2023_default())
    },
    {
        name: "JavaScript Meetup",
        image: (JavaScriptMeetup_default())
    },
    {
        name: "Kotlin Conf KUG Kolkata",
        image: (KotlinConfKUGKolkata1_default())
    },
    {
        name: "Upesacm Tech",
        image: (UpesacmTech_default())
    }, 
];
var Section4 = [
    {
        name: "Azuga",
        image: (AzugaLogo2_default())
    },
    {
        name: "Devnation Site Day",
        image: (DM2_default())
    },
    {
        name: "EduHub",
        image: (EduHub_default())
    },
    {
        name: "Flutter Nashik",
        image: (Flutternashik_default())
    },
    {
        name: "GDG Trichy",
        image: (GDGTrichy_default())
    },
    {
        name: "AWS ReCap",
        image: (ReCap_default())
    },
    {
        name: "Soda Foundation",
        image: (SodaFoundation_default())
    },
    {
        name: "Study Jam",
        image: (StudyJam_default())
    },
    {
        name: "Women In Data",
        image: (WomenInData_default())
    },
    {
        name: "GDG WOW",
        image: (WOW_default())
    }, 
];

;// CONCATENATED MODULE: ./src/pages/UseCases/TrainingsAndHackthons.js







var TrainingsAndHackthons_TrainingAndHackathons = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "204ee861fd84bde3",
                        [
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title
                        ]
                    ]
                ]) + " " + "".concat(title, "-root d-flex justify-content-center align-items-center flex-row px-5 px-mob  pt-4 pb-5 g-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: style_default().dynamic([
                        [
                            "204ee861fd84bde3",
                            [
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title
                            ]
                        ]
                    ]) + " " + "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: style_default().dynamic([
                                [
                                    "204ee861fd84bde3",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ".concat(title, "-details-root"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: style_default().dynamic([
                                        [
                                            "204ee861fd84bde3",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-title"),
                                    children: "Trainings & Hackthons"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "204ee861fd84bde3",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-text mt-1"),
                                    children: "One-stop solution for events like workshops and hackathons!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "204ee861fd84bde3",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "".concat(title, "-RootImageDesktop"),
                                        src: "/img/useCases/TrainingAndHackathons.png",
                                        alt: "TrainingAndHackathonsImg",
                                        width: 300,
                                        height: 200
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "204ee861fd84bde3",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-subText mt-md-4"),
                                    children: [
                                        "For small events such as workshops, trainings and hackathons, KonfHub offers comprehensive solution:",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: style_default().dynamic([
                                                [
                                                    "204ee861fd84bde3",
                                                    [
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "204ee861fd84bde3",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Branded event pages that are customizable to your needs"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "204ee861fd84bde3",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Collect participant registration (can be downloaded later)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "204ee861fd84bde3",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Engage participants using live quizzing"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "204ee861fd84bde3",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Collect feedback and automatically issue participation certificates"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: style_default().dynamic([
                                [
                                    "204ee861fd84bde3",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: style_default().dynamic([
                                    [
                                        "204ee861fd84bde3",
                                        [
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title
                                        ]
                                    ]
                                ]) + " " + "".concat(title, "-image mx-md-5 d-flex justify-content-center align-items-center px-md-3"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "".concat(title, "-RootImageDesktop"),
                                    src: "/img/useCases/TrainingAndHackathons.png",
                                    alt: "TrainingAndHackathonsImg",
                                    width: 555,
                                    height: 370
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasesCarosel, {
                            data: Section4
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "204ee861fd84bde3",
                dynamic: [
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title
                ],
                children: ".".concat(title, "-root.__jsx-style-dynamic-selector{background:#f6f9fc;padding:50px 0px;padding-left:105px;padding-right:105px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{max-width:100%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-title.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:800;font-size:42px;line-height:57px;color:#572148}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-text.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:700;font-size:22px;line-height:30px;text-align:left;color:#616161}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-subText.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:500;font-size:18px;line-height:27px;color:#4f4f4f}.desktop-none.__jsx-style-dynamic-selector{display:none!important}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector ul.__jsx-style-dynamic-selector{margin-bottom:0px!important}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-ideaRoot.__jsx-style-dynamic-selector{background:#d8d8d8;-webkit-border-radius:6px;-moz-border-radius:6px;border-radius:6px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-ideaText.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:500;font-size:18px;line-height:25px;color:#2c2c2c}.').concat(title, "-image.__jsx-style-dynamic-selector{margin-top:50px;max-width:100%}@media only screen and (max-width:992px){.mob-none.__jsx-style-dynamic-selector{display:none!important}.desktop-none.__jsx-style-dynamic-selector{display:-webkit-box!important;display:-webkit-flex!important;display:-moz-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (max-width:722px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:50px;padding-right:50px}}@media screen and (max-width:679px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:30px;padding-right:30px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px}}@media screen and (max-width:480px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:10px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-title.__jsx-style-dynamic-selector{font-weight:800;font-size:24px;line-height:33px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-text.__jsx-style-dynamic-selector{font-weight:700;font-size:14px;line-height:19px;width:80%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector{font-weight:500;font-size:16px;line-height:22px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-ideaText.__jsx-style-dynamic-selector{font-weight:500;font-size:14px;line-height:19px}}")
            })
        ]
    });
};
/* harmony default export */ var TrainingsAndHackthons = (TrainingsAndHackthons_TrainingAndHackathons);

// EXTERNAL MODULE: ./public/img/useCases/dots.webp
var dots = __webpack_require__(89112);
var dots_default = /*#__PURE__*/__webpack_require__.n(dots);
// EXTERNAL MODULE: ./src/config/config.js
var config = __webpack_require__(35055);
;// CONCATENATED MODULE: ./src/pages/UseCases/EngageAudience.js






var EngageAudience = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: style_default().dynamic([
                    [
                        "ed7b2d7281d60cbe",
                        [
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            (dots_default()),
                            title,
                            (dots_default()),
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            (dots_default()),
                            title,
                            (dots_default()),
                            title,
                            (dots_default())
                        ]
                    ]
                ]) + " " + "".concat(title, "-root"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: style_default().dynamic([
                            [
                                "ed7b2d7281d60cbe",
                                [
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default()),
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default())
                                ]
                            ]
                        ]) + " " + "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: style_default().dynamic([
                                    [
                                        "ed7b2d7281d60cbe",
                                        [
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            (dots_default()),
                                            title,
                                            (dots_default()),
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            (dots_default()),
                                            title,
                                            (dots_default()),
                                            title,
                                            (dots_default())
                                        ]
                                    ]
                                ]) + " " + "col-lg-6 col-md-12 ".concat(title, "-details-root"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: style_default().dynamic([
                                            [
                                                "ed7b2d7281d60cbe",
                                                [
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default())
                                                ]
                                            ]
                                        ]) + " " + "".concat(title, "-title"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: style_default().dynamic([
                                                    [
                                                        "ed7b2d7281d60cbe",
                                                        [
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default())
                                                        ]
                                                    ]
                                                ]) + " " + "engage ",
                                                children: "Engage & Excite"
                                            }),
                                            "Your audience in any kind of events!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "ed7b2d7281d60cbe",
                                                [
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default())
                                                ]
                                            ]
                                        ]) + " " + "pt-4 d-block d-sm-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "".concat(title, "-RootImageDesktop"),
                                            src: "/img/useCases/AudienceUseCases.png",
                                            alt: "Audience use cases",
                                            width: 350,
                                            height: 350
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "ed7b2d7281d60cbe",
                                                [
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default())
                                                ]
                                            ]
                                        ]) + " " + "".concat(title, "-subText mt-4"),
                                        children: "Organizing large events is a challenging task. KonfHub has features and benefits that automate and simplify most of your tasks. Read more to know how!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "ed7b2d7281d60cbe",
                                                [
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default())
                                                ]
                                            ]
                                        ]) + " " + "my-5",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://calendly.com/tanvi-konfhub/konfhub-quizhub-walk-through",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: style_default().dynamic([
                                                    [
                                                        "ed7b2d7281d60cbe",
                                                        [
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default())
                                                        ]
                                                    ]
                                                ]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "ed7b2d7281d60cbe",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                (dots_default())
                                                            ]
                                                        ]
                                                    ]) + " " + "btn btn-header mb-lg-2 mb-xxl-2 me-2 me-sm-0 btn-demo schedule-demo",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "ed7b2d7281d60cbe",
                                                                    [
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default())
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: "Schedule Demo"
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "ed7b2d7281d60cbe",
                                                                    [
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default())
                                                                    ]
                                                                ]
                                                            ]) + " " + "fas fa-chevron-circle-right arrow"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "".concat(config/* hostEventUrl */.K4, "/create/event"),
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: style_default().dynamic([
                                                    [
                                                        "ed7b2d7281d60cbe",
                                                        [
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default()),
                                                            title,
                                                            (dots_default())
                                                        ]
                                                    ]
                                                ]),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "ed7b2d7281d60cbe",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                (dots_default()),
                                                                title,
                                                                (dots_default())
                                                            ]
                                                        ]
                                                    ]) + " " + "btn btn-header mb-lg-2 ms-0 ms-lg-5 ms-sm-3 mt-sm-0 mt-3 schedule-demo",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "ed7b2d7281d60cbe",
                                                                    [
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default())
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: "Host an Event"
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "ed7b2d7281d60cbe",
                                                                    [
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default()),
                                                                        title,
                                                                        (dots_default())
                                                                    ]
                                                                ]
                                                            ]) + " " + "fas fa-chevron-circle-right arrow"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: style_default().dynamic([
                                    [
                                        "ed7b2d7281d60cbe",
                                        [
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            (dots_default()),
                                            title,
                                            (dots_default()),
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            (dots_default()),
                                            title,
                                            (dots_default()),
                                            title,
                                            (dots_default())
                                        ]
                                    ]
                                ]) + " " + "col-lg-6 col-md-12 d-none d-sm-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "ed7b2d7281d60cbe",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                (dots_default()),
                                                title,
                                                (dots_default()),
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                (dots_default()),
                                                title,
                                                (dots_default()),
                                                title,
                                                (dots_default())
                                            ]
                                        ]
                                    ]) + " " + "py-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "ed7b2d7281d60cbe",
                                                [
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default()),
                                                    title,
                                                    (dots_default())
                                                ]
                                            ]
                                        ]) + " " + "".concat(title, "-image py-2 d-flex justify-content-start"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "".concat(title, "-RootImageDesktop"),
                                            src: "/img/useCases/AudienceUseCases.png",
                                            alt: "Audience use cases",
                                            width: 660,
                                            height: 551
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: style_default().dynamic([
                            [
                                "ed7b2d7281d60cbe",
                                [
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default()),
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default())
                                ]
                            ]
                        ]) + " " + "dots-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: style_default().dynamic([
                            [
                                "ed7b2d7281d60cbe",
                                [
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default()),
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default()),
                                    title,
                                    (dots_default())
                                ]
                            ]
                        ]) + " " + "dots-2"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "ed7b2d7281d60cbe",
                dynamic: [
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    (dots_default()),
                    title,
                    (dots_default()),
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    (dots_default()),
                    title,
                    (dots_default()),
                    title,
                    (dots_default())
                ],
                children: ".".concat(title, "-root.__jsx-style-dynamic-selector{background:#f6f9fc;padding:50px 0px;padding-left:105px;padding-right:105px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:50px;margin-top:40px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-title.__jsx-style-dynamic-selector{font-family:"Poppins";font-weight:600;font-size:41px;line-height:53px;color:#572148}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-title.__jsx-style-dynamic-selector .engage.__jsx-style-dynamic-selector{color:#fb5850;margin-right:8px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-subText.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:500;font-size:18px;line-height:28px;color:#525252;padding-right:40px}.').concat(title, "-root.__jsx-style-dynamic-selector .dots-1.__jsx-style-dynamic-selector{background:url(").concat((dots_default()), ")no-repeat;width:130px;height:96px;position:absolute;top:130px;left:85px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.").concat(title, "-root.__jsx-style-dynamic-selector .dots-2.__jsx-style-dynamic-selector{background:url(").concat((dots_default()), ")no-repeat;width:130px;height:96px;position:absolute;top:230px;left:550px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{max-width:100%;margin-top:-50px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-image.__jsx-style-dynamic-selector{width:auto;margin-top:-50px}@media screen and (max-width:722px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:50px;padding-right:50px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{position:relative;top:0px;right:215px;max-width:80%}}@media screen and (max-width:679px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:30px;padding-right:30px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{position:relative;top:50px;right:15px;max-width:80%!important}.").concat(title, "-root.__jsx-style-dynamic-selector .dots-2.__jsx-style-dynamic-selector{position:absolute;top:140px;left:349px}}@media screen and (max-width:480px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:20px;padding-right:20px;padding-bottom:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-title.__jsx-style-dynamic-selector{font-weight:600;font-size:30px;line-height:45px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector{font-weight:500;font-size:16px;line-height:22px;padding-right:0px}.schedule-demo.__jsx-style-dynamic-selector{width:100%!important;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.").concat(title, "-root.__jsx-style-dynamic-selector .dots-1.__jsx-style-dynamic-selector{background:url(").concat((dots_default()), ")no-repeat;width:130px;height:96px;position:absolute;top:115px;left:10px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}.").concat(title, "-root.__jsx-style-dynamic-selector .dots-2.__jsx-style-dynamic-selector{background:url(").concat((dots_default()), ")no-repeat;width:130px;height:96px;position:absolute;top:200px;left:285px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}}@media screen and (max-width:400px){.").concat(title, "-root.__jsx-style-dynamic-selector .dots-2.__jsx-style-dynamic-selector{background:url(").concat((dots_default()), ")no-repeat;width:130px;height:96px;position:absolute;top:190px;left:235px;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}}")
            })
        ]
    });
};
/* harmony default export */ var UseCases_EngageAudience = (EngageAudience);

;// CONCATENATED MODULE: ./src/pages/UseCases/CollegeFestsAndCulturalEvents.js






var CollegeFestsAndCulturalEvents = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "5e873d19802f8e67",
                        [
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title
                        ]
                    ]
                ]) + " " + "".concat(title, "-root d-flex justify-content-center align-items-center flex-row px-5 px-mob  pt-4 pb-5 g-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: style_default().dynamic([
                        [
                            "5e873d19802f8e67",
                            [
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title
                            ]
                        ]
                    ]) + " " + "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: style_default().dynamic([
                                [
                                    "5e873d19802f8e67",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ".concat(title, "-details-root"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: style_default().dynamic([
                                        [
                                            "5e873d19802f8e67",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-title"),
                                    children: "College Fests & Cultural Events"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "5e873d19802f8e67",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-text mt-1"),
                                    children: "KonfHub streamlines academic tech festivals"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "5e873d19802f8e67",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "".concat(title, "-RootImageDesktop"),
                                        src: "/img/useCases/CollegeFestAndCulturalEvents.png",
                                        alt: "TechFestAndHackathonsImg",
                                        width: 320,
                                        height: 320
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "5e873d19802f8e67",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-subText mt-md-4"),
                                    children: [
                                        "Academic technology festivals are no easy feat, especially with a large number of participants. Luckily, KonfHub comes to the rescue by providing effective features for overcoming the many challenges involved in organizing such events.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: style_default().dynamic([
                                                [
                                                    "5e873d19802f8e67",
                                                    [
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "5e873d19802f8e67",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Efficiently manage multiple tickets and discount codes"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "5e873d19802f8e67",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Generate combined tickets for participants purchasing multiple event tickets"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "5e873d19802f8e67",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Seamlessly manage hundreds or thousands of attendees with the check-in app at registration desks"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "5e873d19802f8e67",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Reward participants with participation certificates and gather valuable feedback"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: style_default().dynamic([
                                [
                                    "5e873d19802f8e67",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: style_default().dynamic([
                                    [
                                        "5e873d19802f8e67",
                                        [
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title
                                        ]
                                    ]
                                ]) + " " + "mx-md-5 d-flex justify-content-center align-items-center px-md-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "".concat(title, "-RootImageDesktop"),
                                    src: "/img/useCases/CollegeFestAndCulturalEvents.png",
                                    alt: "TechFestAndHackathonsImg",
                                    width: 550,
                                    height: 550
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasesCarosel, {
                            data: Section2
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "5e873d19802f8e67",
                dynamic: [
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title
                ],
                children: ".".concat(title, "-root.__jsx-style-dynamic-selector{background:#f6f9fc;padding:50px 0px;padding-left:105px;padding-right:105px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:10px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-title.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:800;font-size:42px;line-height:57px;color:#572148}.desktop-none.__jsx-style-dynamic-selector{display:none!important}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-text.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:700;font-size:22px;line-height:30px;text-align:left;color:#616161}.').concat(title, "-root.__jsx-style-dynamic-selector ").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{max-width:100%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-subText.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:500;font-size:18px;line-height:27px;color:#4f4f4f}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector ul.__jsx-style-dynamic-selector{margin-bottom:0px!important}@media screen and (max-width:722px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:50px;padding-right:50px}}@media only screen and (max-width:992px){.mob-none.__jsx-style-dynamic-selector{display:none!important}.desktop-none.__jsx-style-dynamic-selector{display:-webkit-box!important;display:-webkit-flex!important;display:-moz-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (max-width:679px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:30px;padding-right:30px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px}}@media screen and (max-width:480px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:10px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-title.__jsx-style-dynamic-selector{font-weight:800;font-size:24px;line-height:33px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-text.__jsx-style-dynamic-selector{font-weight:700;font-size:14px;line-height:19px;width:80%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector{font-weight:500;font-size:16px;line-height:22px}}")
            })
        ]
    });
};
/* harmony default export */ var UseCases_CollegeFestsAndCulturalEvents = (CollegeFestsAndCulturalEvents);

;// CONCATENATED MODULE: ./src/pages/UseCases/MeetupsAndWebinars.js






var MeetupsAndWebinars = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "9d604d5144f89428",
                        [
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title
                        ]
                    ]
                ]) + " " + "".concat(title, "-root d-flex justify-content-center align-items-center flex-row px-5 px-mob pb-5 pt-4 g-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: style_default().dynamic([
                        [
                            "9d604d5144f89428",
                            [
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title
                            ]
                        ]
                    ]) + " " + "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: style_default().dynamic([
                                [
                                    "9d604d5144f89428",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: style_default().dynamic([
                                    [
                                        "9d604d5144f89428",
                                        [
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title
                                        ]
                                    ]
                                ]) + " " + "".concat(title, "-image mx-md-5 d-flex justify-content-center align-items-center px-md-3"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "".concat(title, "-RootImageDesktop"),
                                    src: "/img/useCases/MeetupsAndWebinars.png",
                                    alt: "MeetupsAndWebinars",
                                    width: 500,
                                    height: 450
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: style_default().dynamic([
                                [
                                    "9d604d5144f89428",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ".concat(title, "-details-root"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: style_default().dynamic([
                                        [
                                            "9d604d5144f89428",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-title"),
                                    children: "Meetups & Webinars"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "9d604d5144f89428",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-text mt-1"),
                                    children: "Organize meetups and webinars effortlessly with KonfHub"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "9d604d5144f89428",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-image-responsive mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "".concat(title, "-RootImageDesktop"),
                                        src: "/img/useCases/MeetupsAndWebinars.png",
                                        alt: "MeetupsAndWebinars",
                                        width: 260,
                                        height: 250
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "9d604d5144f89428",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-subText mt-4"),
                                    children: [
                                        "KonfHub provides a convenient solution for organizing community meetups and online webinars by streamlining the registration process and ensuring the smooth execution of your event.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: style_default().dynamic([
                                                [
                                                    "9d604d5144f89428",
                                                    [
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "9d604d5144f89428",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Quick and easy registration process with the option to add more fields"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "9d604d5144f89428",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Live quizzing feature to engage and excite participants during the event"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "9d604d5144f89428",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Automatic issuance of participation certificates to incentivize participation"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "9d604d5144f89428",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Ability to contact participants through email, WhatsApp, and SMS campaigns"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "9d604d5144f89428",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Creation of customizable and branded event pages in a quick and efficient manner"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasesCarosel, {
                            data: Section3
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "9d604d5144f89428",
                dynamic: [
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title
                ],
                children: ".".concat(title, "-root.__jsx-style-dynamic-selector{background:#fff;padding:50px 0px;padding-left:105px;padding-right:105px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-left:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-title.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:800;font-size:42px;line-height:57px;color:#572148}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-text.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:700;font-size:22px;line-height:30px;text-align:left;color:#616161}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-subText.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:500;font-size:18px;line-height:27px;color:#4f4f4f;margin-bottom:40px}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{max-width:100%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-image.__jsx-style-dynamic-selector{margin-top:-20px max-width:100%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-image-responsive.__jsx-style-dynamic-selector{margin-top:20px;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.desktop-none.__jsx-style-dynamic-selector{display:none!important}@media screen and (max-width:722px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:50px;padding-right:50px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-left:0px}}@media only screen and (max-width:992px){.mob-none.__jsx-style-dynamic-selector{display:none!important}.desktop-none.__jsx-style-dynamic-selector{display:-webkit-box!important;display:-webkit-flex!important;display:-moz-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (max-width:679px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:30px;padding-right:30px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px}}@media screen and (max-width:480px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-left:10px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-title.__jsx-style-dynamic-selector{font-weight:800;font-size:24px;line-height:33px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-text.__jsx-style-dynamic-selector{font-weight:700;font-size:14px;line-height:19px;width:80%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector{font-weight:500;font-size:16px;line-height:22px}}")
            })
        ]
    });
};
/* harmony default export */ var UseCases_MeetupsAndWebinars = (MeetupsAndWebinars);

;// CONCATENATED MODULE: ./src/pages/UseCases/ConferencesAndSummits.js






var ConferencesAndSummits = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: style_default().dynamic([
                    [
                        "fe37bc70c884f902",
                        [
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title,
                            title
                        ]
                    ]
                ]) + " " + "".concat(title, "-root d-flex justify-content-center align-items-center flex-row px-5 px-mob pb-5 pt-4 g-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: style_default().dynamic([
                        [
                            "fe37bc70c884f902",
                            [
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title,
                                title
                            ]
                        ]
                    ]) + " " + "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: style_default().dynamic([
                                [
                                    "fe37bc70c884f902",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 mob-none col py-md-3 d-flex justify-content-center flex-column align-items-center px-md-3 ps-lg-5 pe-lg-5 py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: style_default().dynamic([
                                    [
                                        "fe37bc70c884f902",
                                        [
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title,
                                            title
                                        ]
                                    ]
                                ]) + " " + "".concat(title, "-image mx-md-5 d-flex justify-content-center align-items-center px-md-3"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "".concat(title, "-RootImageDesktop"),
                                    src: "/img/useCases/ConferenceAndSummits.png",
                                    alt: "ConferencesAndSummits",
                                    width: 550,
                                    height: 390
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: style_default().dynamic([
                                [
                                    "fe37bc70c884f902",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]) + " " + "col-lg-6 col pb-md-3 pt-md-5 px-md-3 py-3 px-lg-3 ps-lg-5 ".concat(title, "-details-root"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: style_default().dynamic([
                                        [
                                            "fe37bc70c884f902",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-title"),
                                    children: "Conferences & Summits"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "fe37bc70c884f902",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-text mt-1"),
                                    children: "KonfHub simplifies event planning with customizable features"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "fe37bc70c884f902",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-image mx-md-5 desktop-none d-flex justify-content-center align-items-center px-md-3"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "".concat(title, "-RootImageDesktop"),
                                        src: "/img/useCases/ConferenceAndSummits.png",
                                        alt: "ConferencesAndSummits",
                                        width: 320,
                                        height: 225
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "fe37bc70c884f902",
                                            [
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title,
                                                title
                                            ]
                                        ]
                                    ]) + " " + "".concat(title, "-subText mt-md-4"),
                                    children: [
                                        "KonfHub can simplify the lives of event organizers by assisting with the planning of large tech conferences, whether organized by corporate or developer/student communities. KonfHub helps your life as an organizer easier.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: style_default().dynamic([
                                                [
                                                    "fe37bc70c884f902",
                                                    [
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title,
                                                        title
                                                    ]
                                                ]
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "fe37bc70c884f902",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Increase registrations with automated referral contests"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "fe37bc70c884f902",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Utilize customizable ticketing options to fit your requirements"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "fe37bc70c884f902",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Keep attendees engaged with live quizzes during the event"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "fe37bc70c884f902",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Benefit from features such as hidden tickets and approval-based registrations"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "fe37bc70c884f902",
                                                            [
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title,
                                                                title
                                                            ]
                                                        ]
                                                    ]),
                                                    children: "Conveniently use check-in and sponsor apps"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: style_default().dynamic([
                                [
                                    "fe37bc70c884f902",
                                    [
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title,
                                        title
                                    ]
                                ]
                            ]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasesCarosel, {
                                data: Section1
                            })
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "fe37bc70c884f902",
                dynamic: [
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title,
                    title
                ],
                children: ".".concat(title, "-root.__jsx-style-dynamic-selector{background:#fff;padding:50px 0px;padding-left:105px;padding-right:105px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-left:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-title.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:800;font-size:42px;line-height:57px;color:#572148}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-text.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:700;font-size:22px;line-height:30px;text-align:left;color:#616161}.desktop-none.__jsx-style-dynamic-selector{display:none!important}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, '-subText.__jsx-style-dynamic-selector{font-family:"Nunito";font-weight:500;font-size:18px;line-height:27px;color:#4f4f4f}.').concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-RootImageDesktop.__jsx-style-dynamic-selector{max-width:100%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-image.__jsx-style-dynamic-selector{margin-top:10px;max-width:100%}@media screen and (max-width:722px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:50px;padding-right:50px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-left:0px}}@media only screen and (max-width:992px){.mob-none.__jsx-style-dynamic-selector{display:none!important}.desktop-none.__jsx-style-dynamic-selector{display:-webkit-box!important;display:-webkit-flex!important;display:-moz-box!important;display:-ms-flexbox!important;display:flex!important}}@media screen and (max-width:679px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:30px;padding-right:30px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-right:0px}}@media screen and (max-width:480px){.").concat(title, "-root.__jsx-style-dynamic-selector{padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:0px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector{padding-left:10px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-title.__jsx-style-dynamic-selector{font-weight:800;font-size:24px;line-height:33px}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-text.__jsx-style-dynamic-selector{font-weight:700;font-size:14px;line-height:19px;width:80%}.").concat(title, "-root.__jsx-style-dynamic-selector .").concat(title, "-details-root.__jsx-style-dynamic-selector .").concat(title, "-subText.__jsx-style-dynamic-selector{font-weight:500;font-size:16px;line-height:22px}}")
            })
        ]
    });
};
/* harmony default export */ var UseCases_ConferencesAndSummits = (ConferencesAndSummits);

// EXTERNAL MODULE: ./src/pages/Home/HomeNav.js + 1 modules
var HomeNav = __webpack_require__(11483);
// EXTERNAL MODULE: ./src/pages/Home/HomeFooter.js
var HomeFooter = __webpack_require__(24714);
;// CONCATENATED MODULE: ./src/pages/UseCases/UseCases.js










var UseCases = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNav["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCases_EngageAudience, {
                title: "EngageAudience"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCases_ConferencesAndSummits, {
                title: "ConferencesAndSummits"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCases_CollegeFestsAndCulturalEvents, {
                title: "CollegeFestsAndCulturalEvents"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCases_MeetupsAndWebinars, {
                title: "MeetupsAndWebinars"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainingsAndHackthons, {
                title: "TrainingsAndHackthons"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFooter["default"], {})
        ]
    });
};
/* harmony default export */ var UseCases_UseCases = ((0,router.withRouter)(UseCases));

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/config/next-seo.config.js
var next_seo_config = __webpack_require__(37009);
;// CONCATENATED MODULE: ./pages/usecases.js







var usecases = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, (0,next_seo_config/* seoFunct */.M)("useCasesSeo"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCases_UseCases, {})
        ]
    });
};
/* harmony default export */ var pages_usecases = ((0,router.withRouter)(usecases));


/***/ }),

/***/ 82817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q2": function() { return /* binding */ removeCognitoFromLocalStorage; }
/* harmony export */ });
/* unused harmony exports diff, numberWithCommas, handleLogout */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var aws_amplify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95707);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);






function diff(x, y) {
    var keys = _to_consumable_array(Object.keys(x)).concat(_to_consumable_array(Object.keys(y))), diff = {};
    keys.map(function(key) {
        if (JSON.stringify(y[key]) !== JSON.stringify(x[key])) {
            if (x[key] !== undefined) diff[key] = x[key];
        }
    });
    return diff;
}
function numberWithCommas(x) {
    if (x === undefined) return "0";
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while(pattern.test(x))x = x.replace(pattern, "$1,$2");
    return x;
}
function removeCognitoFromLocalStorage() {
    for(var key in localStorage){
        if (key.includes("CognitoIdentityServiceProvider")) localStorage.removeItem(key);
    }
}
var handleLogout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(e, authContext) {
        var cookies, message, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    aws_amplify__WEBPACK_IMPORTED_MODULE_4__/* .Auth.signOut */ .g.signOut();
                    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove("authToken");
                    removeCognitoFromLocalStorage();
                    cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get();
                    Object.keys(cookies).map(function(key) {
                        if (key.includes("CognitoIdentityServiceProvider")) js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(key);
                    });
                    authContext.setAuth({
                        attributes: {}
                    }, false);
                    return [
                        4,
                        aws_amplify__WEBPACK_IMPORTED_MODULE_4__/* .Auth.signOut */ .g.signOut()
                    ];
                case 2:
                    _state.sent();
                    message = "Logged Out Successfully";
                    successToaster(message);
                    next_router__WEBPACK_IMPORTED_MODULE_1___default().replace("/", undefined, {
                        shallow: false
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleLogout(e, authContext) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 67292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



//import ReactPlaceholder from 'react-placeholder';
//import 'react-placeholder/lib/reactPlaceholder.css';
var Loading = function(param) {
    var size = param.size, weight = param.weight, className = param.className, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "d8ac03edd80a0a48",
                [
                    size ? size : "2rem",
                    size ? size : "2rem",
                    weight ? weight : "18px",
                    color ? color : "#0d6efd"
                ]
            ]
        ]) + " " + ((className ? className : "") || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "status",
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "d8ac03edd80a0a48",
                        [
                            size ? size : "2rem",
                            size ? size : "2rem",
                            weight ? weight : "18px",
                            color ? color : "#0d6efd"
                        ]
                    ]
                ]) + " " + "spinner-border text-primary"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d8ac03edd80a0a48",
                dynamic: [
                    size ? size : "2rem",
                    size ? size : "2rem",
                    weight ? weight : "18px",
                    color ? color : "#0d6efd"
                ],
                children: ".spinner-border.__jsx-style-dynamic-selector{width:".concat(size ? size : "2rem", "!important;height:").concat(size ? size : "2rem", "!important;font-size:").concat(weight ? weight : "18px", "!important;color:").concat(color ? color : "#0d6efd", "!important}")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Loading);


/***/ }),

/***/ 88279:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0idXJsKCNwYXR0ZXJuMCkiLz4KPGRlZnM+CjxwYXR0ZXJuIGlkPSJwYXR0ZXJuMCIgcGF0dGVybkNvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHdpZHRoPSIxIiBoZWlnaHQ9IjEiPgo8dXNlIHhsaW5rOmhyZWY9IiNpbWFnZTBfMV80IiB0cmFuc2Zvcm09InNjYWxlKDAuMDEwNDE2NykiLz4KPC9wYXR0ZXJuPgo8aW1hZ2UgaWQ9ImltYWdlMF8xXzQiIHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgeGxpbms6aHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFHQUFBQUJnQ0FZQUFBRGltSGM0QUFBQUNYQklXWE1BQUFzVEFBQUxFd0VBbXB3WUFBQUNwMGxFUVZSNG5PMmRPMjVVUVJCRlh3UWhnaGdSVkJQeDJZVzdRQ0wyQ3BCRzlFV3NnZEFrV0lBTWJBWklJWGhFd0VJQWgwYUQyaU1RQ01hZTVIVlZWOThqVmZ5bTd1blBhRDdkMDBRSUlZUVFRZ2doaEJCQ3lJNDhsTDNiSmVuekl2bHpFVDFHMG5Ya0txTEh0VmNrZmZaQThpMnpnZkxvK3QyTEplVlhKZVVmMXFIQVNrYnRYZlRsL28zOUM4M0RoK1IzMWdIQVQ3MXRLZ0VwdjNiUTlOcFZpUjQxWFBQSFhYYXd0ZklKMHAyYml3dW9HNjU5cytxeWl1amg0Z0lnK1l0MW8vQmJueFlYVUVTL08yaDA3YklrZjF0Y2dIbVR5WGRSUUtJQTgxRUl6Z0Q3SU1BbHlENE1HQlQzZ0VRQjVxTVFuQUgyUVlCTGtIMFlNS2l3ZTBCSithQ0lmckFPZUV3Qm9vL3JzMWV5ZHdtaTc2MURIa3VBYk1ML2hYY0pzUVRJMytIM0lDR09BUGwvK040bGhCQlFVajdZNWJWVUNkNDI1aGdDSkgrOGYxV3Y3Q3JCMDB3SUlRQWRTd2dqQUoxS0NDVUFIVW9JSndDZFNRZ3BBQjFKQ0NzQW5VZ0lMUUFkU0FndkFNNGxMQzZnUjFZTkpWajNPbzB1WVNLMkVzNTRQR2toNGZRaHhPNFQxRE1lVFZZTlByNW15c2JmSFd4Ny90Q3NHbjV4czNnekxackErVFdYYS9jdWV3dC9GQUd6MS9CSEVEQjdEais2Z05sNytKRUZ6RDJFSDFYQTNFdjRFUVhNUFlVZlRjRGNXL2lSQk13OWhoOUdRT0ZQRTIwRjRMVHlrNTVHZnFnWmdITWtlQTAvb0FEOVI0TG44SU1LME44U3ZJY2ZXSUR5VDNyV0F0QkpoWjBCNktRb0lGR0ErU2dFWjRCOUVPQVNaQjhHRElwN1FLSUE4MUVJemdEN0lCQjFDZUxCcmJvMS9DTDU2L0o3QUk4dVhwc2VYVnh2anJDZTV2QmFvazhYRjFDdjdkZ2MxZTZnNFRUZzhmV1ZlbTJIZmNQcXF5Uy9tRnBScit1bzEzYVlONTE4VkVuNnB2azlNcWNTUkkvR1hvN3lTUjM1emNQL2s3cnUxWnNqNmp1QUVkNmlsazJQdGRmRFptcytJWVFRUWdnaGhCQkNDSmtpOEJPMU9CN3lSdkVES3dBQUFBQkpSVTVFcmtKZ2dnPT0iLz4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ 81084:
/***/ (function(module) {

module.exports = "/_next/static/images/AWSCDSingapore2-89eca28b170d57f4352a8d352c07f9fc.jpg";

/***/ }),

/***/ 55124:
/***/ (function(module) {

module.exports = "/_next/static/images/AWSCDSriLanka2-fbdd06b4922ca5f10e531a99fe2b411d.jpg";

/***/ }),

/***/ 16043:
/***/ (function(module) {

module.exports = "/_next/static/images/AWSCDVirtualEdition2-809a3de5143ee1d62f0ac1789c19926f.jpg";

/***/ }),

/***/ 87382:
/***/ (function(module) {

module.exports = "/_next/static/images/AWSPune-f155a28d78edc45587a387f75b42b5cd.jpg";

/***/ }),

/***/ 4525:
/***/ (function(module) {

module.exports = "/_next/static/images/DataOpsObservabilityConf2-59db0386b17e5b2e110793d950840482.jpg";

/***/ }),

/***/ 27428:
/***/ (function(module) {

module.exports = "/_next/static/images/DevNation2-a1028b2078cbf05562310ea77c453a9e.jpg";

/***/ }),

/***/ 41393:
/***/ (function(module) {

module.exports = "/_next/static/images/DevOpsDaysIndia2-466175d5f27b349cd199f155d39119cc.jpg";

/***/ }),

/***/ 63013:
/***/ (function(module) {

module.exports = "/_next/static/images/DevfestAurangabad2-9ac05aa801b37b4d5b5f091c64751806.jpg";

/***/ }),

/***/ 86502:
/***/ (function(module) {

module.exports = "/_next/static/images/ExpertsLive2-14a63b382347e49d0d94757441a44d58.jpg";

/***/ }),

/***/ 15324:
/***/ (function(module) {

module.exports = "/_next/static/images/GDGPune2023-92f059ebaaba3b7c3f4fbba4ad1f9078.jpg";

/***/ }),

/***/ 51538:
/***/ (function(module) {

module.exports = "/_next/static/images/JECRCCLOUDSUMMIT2-618c3cd08057a28a883d35fb2ae6b5a6.jpg";

/***/ }),

/***/ 12640:
/***/ (function(module) {

module.exports = "/_next/static/images/KCDMumbai-e81782e9d9bb24e7876e06ee06bbc994.jpg";

/***/ }),

/***/ 75487:
/***/ (function(module) {

module.exports = "/_next/static/images/PyConfHyderabad2-061d33c13d854145842802f6b22bd4bd.jpg";

/***/ }),

/***/ 94473:
/***/ (function(module) {

module.exports = "/_next/static/images/AzugaLogo2-1a957ab2043dd45e11dc069a533e48c9.jpg";

/***/ }),

/***/ 6263:
/***/ (function(module) {

module.exports = "/_next/static/images/DM2-fe826675dfb66afba9371c99d43faec2.jpg";

/***/ }),

/***/ 28099:
/***/ (function(module) {

module.exports = "/_next/static/images/EduHub-265269a4ddc97d225fcd8c1e066273b2.jpg";

/***/ }),

/***/ 56757:
/***/ (function(module) {

module.exports = "/_next/static/images/Flutternashik-0bab76eef96e13501cc255b97efb3166.jpg";

/***/ }),

/***/ 2687:
/***/ (function(module) {

module.exports = "/_next/static/images/GDGTrichy-8e7777c9e50303a3e19303fcc2d6f059.jpg";

/***/ }),

/***/ 31537:
/***/ (function(module) {

module.exports = "/_next/static/images/ReCap-4ccd25192b329c21fa21e6352c0f5087.jpg";

/***/ }),

/***/ 48719:
/***/ (function(module) {

module.exports = "/_next/static/images/SodaFoundation-ecbd499991f61ba3222a10454837b7bc.jpg";

/***/ }),

/***/ 61418:
/***/ (function(module) {

module.exports = "/_next/static/images/StudyJam-0435464c10d918a233f74bf99ccc771f.jpg";

/***/ }),

/***/ 66872:
/***/ (function(module) {

module.exports = "/_next/static/images/WOW-9560e396b5f51813aa0445e12d1aa871.jpg";

/***/ }),

/***/ 48722:
/***/ (function(module) {

module.exports = "/_next/static/images/WomenInData-904fd210fa17bbd61675a1ec32f6b1b3.jpg";

/***/ }),

/***/ 46551:
/***/ (function(module) {

module.exports = "/_next/static/images/GDSCWOWPUNE-7f299bb42d29f13d472a90e48251180a.jpg";

/***/ }),

/***/ 39654:
/***/ (function(module) {

module.exports = "/_next/static/images/Prakarsh2-9bbb1e0b45c1bbb2dc16ecd70ae55739.jpg";

/***/ }),

/***/ 90598:
/***/ (function(module) {

module.exports = "/_next/static/images/Samhita-61026ad79d7830e0a9220933e1f1bed4.jpg";

/***/ }),

/***/ 43182:
/***/ (function(module) {

module.exports = "/_next/static/images/Tharang2-36be0e4343ffd486b95865e822780e25.jpg";

/***/ }),

/***/ 5605:
/***/ (function(module) {

module.exports = "/_next/static/images/TrainingAndHackathons-63e406f0d12494e478d32c2ad99c5107.png";

/***/ }),

/***/ 17064:
/***/ (function(module) {

module.exports = "/_next/static/images/AWS-67aae38b80818678b8423d9dda6fbd01.jpg";

/***/ }),

/***/ 82759:
/***/ (function(module) {

module.exports = "/_next/static/images/EthnusTech-8e8b7f2cd02fad394e8dad7e2a521c1e.jpg";

/***/ }),

/***/ 55157:
/***/ (function(module) {

module.exports = "/_next/static/images/IWD2023-fb89e502aab052b0fbe1f96f7a626045.jpg";

/***/ }),

/***/ 5748:
/***/ (function(module) {

module.exports = "/_next/static/images/JavaScriptMeetup-55428b4797f0367645e16614a5a17ad8.jpg";

/***/ }),

/***/ 4715:
/***/ (function(module) {

module.exports = "/_next/static/images/KotlinConfKUGKolkata1-7610488a0d1cecd17568d38ceb046003.jpg";

/***/ }),

/***/ 46798:
/***/ (function(module) {

module.exports = "/_next/static/images/UpesacmTech-44d657a25da29573888cc3a59c2d319e.jpg";

/***/ }),

/***/ 89112:
/***/ (function(module) {

module.exports = "data:image/webp;base64,UklGRqAJAABXRUJQVlA4WAoAAAAQAAAAlwAAbwAAQUxQSIAAAAABZ6CwbRsUloYRERD1xaOogttq217sFTp9XsIIBsi9UYxgBEM4amXmncqjfCr+ENF/hW3bNswDu/1BqrWzBcGQQXyqjtaFIoNeVTUChgwmqIEhgwMaYMhAbwEMGXDZoAOGDBZIgSGDARxgyIDrRiQ5WlcQDBk8X/H3/5/5Pf3PCFZQOCD6CAAAsC0AnQEqmABwAD5JIIhEIqKNXkgUAkJZWaFvewOAi/hVWYF+AbAJ4BqKfm/n2dTd6AFaKgAnhBQH4zOZ1R3SvNrzj7lzX+xisQFvXC9Z+3E81f2Z+/H6c/790xPqJf1r/AcCB0AH//2IL5K7W3zNHDXZfpe+CJ7z2eHAP//xAfhX97/f/YBvrHoAf3T0YPoPzQfUfsAfZh///eo/////91HoAfrT////+KLvW/SDaAA6ly7gLEiN+C8AA5Ep7HNEzU0FqlJjlX2QS/jKPGtBlDvUWqFV8YJaDJ++8LZEIdV04TiSUTymwl+FcIW8rvWkURvfvDQ1lede/xT/DgGAA7O1Gk6g+1Y9Y9ZBPhU12tQIBlfgAX8P4fr0grLLINFURITJV2XLJvKXHJgVvonHgww/OtzIB6pH9PcH2UyFa3roG/e2+tnVBOQHVcn98O6qzt6xe2L7zeFBcnkS5gfX3MkfZHQwATtlODxMb391dsanVU7RT2AA/ro0K/mCyc3nmhAHpZAsEiRnuOR4Gf1vB6WS6R1BKy30yXJISVxmkZvGn/J64q97xBwnptvSAfzYac4UV6OTP9HDDr2TDRGWebLmJgfl/w3v//rxrbLfU8tXjE6Gn5U5zcPChrR7LCaF+4uXQwniJKSApqM6MjK0P9glQ8mWuLkDHaV/ENxyhPN9lwlE4SVzad0v/zr3e9v/auaqtHF9fil2zqUggeT/8DwMRNqJbrtzQ2XfcD/d54YneZm+QBURPJG2xlckpckhJXGaRm8af5Tz5eaVlsvAGlZJoBad+LM5o0RnhWh9jFEtagVfboQCQBANvv//9eNbZb6nlq8YnQ1azFS3U+uO3zZUrM88TaqD5WBiwRTSm30SfVWuWF77PoG6EpcSGWHNbyC++/pVwlE4SVzad5UvexYEi9CkfqmZkqsAICYIpSuy3UlbSvI9ACiYdUUJVvlXKfiAf8EAhhzrQwnbRrNQSphZvZ33SZ9PmliCkNoeFDJHwMLlP6M8IQQzcttkRgFNUbKvYNpCc3LQxnxQL8C9qAQZnhtMBMwrfWzIwLljyOya+y3RS8gje0fnGj80jO+d3b/pnV74F9lY52a50XiEhts1W47VYnF1oqjMpTFJibbUE0UGfZrB6VfOW+saJWgoBuZQ44dC48nCguyGVOmObRvUXWkF3d9utvr296nhf7qkVtyodsEHml2qRlj4DcEvrZGvH4UT+hFcYYzUe/3HMCovCXrka5HrzDc5qWcm6oI4ixMYV/ROg9wX286S+UT7q7uwfedjgKaQc7SF2I1Tq8Zdzc1Du6RWzm5aGM+F+e7tTsTgfdzNpgH8o8CvPWL0iYiwB3q30dJFLKVlM4lAj4mvovCBRJ0KhflWAEBMGm/gGcValYa0th+zW6hGHLPt3obf16k8eSkWOXfEC8K+gWJ5SMSMJWwa9QzOcluyscts2/LdjdDP+GHh6l7SdiYTvZ8GFebmf8naXFzEnNjo48xylpngrCB58cV/SPor3yF+cVi6Tfcgr6ATHFU884eqjLOckkKKxy2zEWbdLgivqVBpdVFi/SY9BSSRGINb/e/JxtWjS7+SBoizikc+ELbSFABeNLW9G+sSc152uxOCLNHj22sZRc8wqGNyfF/6judq7AN4LAjqomKLL5e+s7gLfCfqjw5d7krbC96zjvrZkXkmnLOD+YEysWRm8fVjP3Uddgo5YG3dbf34gV6N8YBwL8VxLERXK4jggSr5H32CZQyxwtUyztqsk1MyeLZDjsjNBR0wP7Rt7vLOD+YE5UoK0fox6Yf7+E/BSnz71a8xaBx+hhk/fWs+kv0Yeoc8+F9Zxx79QHHgQYNh/B7v7KU6jqDkdT55oKGU4XbahXrzWtgoGEK/v5darJMusj/JOZ3y85Lmztkf/ZcI7Mtqfj9zhUphnkeq5NlF428Xkoscje1vxntn6dZBLQrPb797yhlaEqVLchr3vERcaaCjpgf2jb3eWcH8wJypQVo/Rj0w/38J+ClPn3q15i0DzBxdarJNGWBO796mb5KKka8owxgUc3/KVy9T2aV2uJVuCv7fV/gNx1ojUuFIfKUqaT9fyAzNnc196HAIAYkNsOyzVyfeNOiL0N4/JoX7XlK9ReGKAVfpxQDlyfz48X2cdckafA6Dv0iI/TSdV3WjDQzJ58RzdtRij05LVsVQvqJbhc1zfVWhLtqewrafRWWn8VenP8MrJTevGxL32lB7MK/wrtXXNmAJCZt3NTCpuluIvRaFhIraRV3BzxKJ0s2e3bGuOcGgXWVYGp+7w56FO+sdKZjHjacmSSFFY49Ca+QKwwU0z3jyGrFNXSo4oZEaE/B49+wz5gtsrO1kPRHPH+xX1NZqMEHdN9K8Zj/fQJo9w9OStR3C9ia1inP/Ftd/HZbLgVMoaB1BZkfVqzJgsxXZsBd0yxtM1uaehgHjOU1BP+cqftvBfDnPq4QsS/r2dDbgDccKC4gDVLIA65AB40K9Ey0DH9lZIuWAMGWn9foYZP8qSS4raq9BD8NMAd58j1wiGE1WrqJW0O3LoJRmJcAiERcz1yvQDmmEnekSNa1xsNsytBEdOZfKmmm4aaEUi1mmFAYYREBQDakXtD3T3PioLvKz8LzQFLlgPZLwhQqovvgNtQPljD/M0o1xC4GG519HBD4kRKUkcZFMfq4NRlvZyzg/mBMoICdLup+3kbLlvl6CIDtCHnJOKqUoMPBXA8hipWU3w8t+U4jxPD1I84dkgPMW8c9L+Gsy1N2ZNt4orjDGaj3ZrLzwqFtJk4DX4iCUBXnrF6RSOLuyimsU2ZvtnyWjVZIS4qWlaNj4X4FNTFsuUINfHOSMZmr46ScluyscehNfIyx8BsaAtxbPM+uueJZzctDGfFLFOs3h87NkLfWJOZhW+tmRhDJOKqUZ7mRb2OXFN3NY5ZbuwfediwNKxjh+ErY6nw1uPukBOU6D5OlP7Hayd7nSRRDSDMy1qsynpJfbRGd1RJY0bkFANzJ6blQBo9JAk8ITN0ASVUnQqF+VYAQEwab+AZnjpcwrAopefTMKdZc59u9AAAAA"

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,1664,1471,1852,4116,7082,1483,4714,9774,2888,179], function() { return __webpack_exec__(32476); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);